import BackButton from "../../components/common/BackButton";
import {useState,useEffect} from "react"; 
import { supabase } from '../../lib/supabaseClient';
import KeywordSection from "../../components/notification/KeywordSection";
import "./KeyWordManage.css";
import { useNavigate } from "react-router-dom";

export default function KeyWordManage(){
  const [notices, setNotices]=useState([]);
  const [losts, setLosts]=useState([]);
  const [notice, setNotice]=useState('');
  const [lost, setLost]=useState('');
  const [sessionId, setSessionId]=useState('');
  const [update, setUpdate]=useState(false);
  const navigate=useNavigate();

  useEffect(()=>{
    const fetchKeyword= async() =>{
      const { data: { session } } = await supabase.auth.getSession();

      if (!session) {
        console.log("세션을 불러오지 못했습니다");
        return;
      }

      const { data: userData, error } = await supabase
      .from("users")
      .select("*")
      .eq("email", session.user.email)
      .single()

      if(error){
        console.log("키워드관리에서 유저이메일을 불러오지 못함");
      }else{
        setSessionId(userData.id);
      
        const {data, error} = await supabase
        .from('keywords')
        .select('*')
        .eq('user_id', userData.id);

        if(error){
          console.error(error);
        }
        else{
          setNotices(data.filter((row) => row.category === '학교 공지사항').map((row) => row.keyword));
          setLosts(data.filter((row) => row.category === '분실물').map((row) => row.keyword));
        }
      }
    }
    fetchKeyword();
  },[])

  function handleKeywordChange(category,e){
    if(category === 'notice'){
      setNotice(e.target.value);
    }
    else if(category==='lost'){
      setLost(e.target.value);
    } 
  }

  function addKeyword(category){
    if(category === 'notice'){
      const trimmedValue = notice.trim(); //공백제거 안하면 크롤링할때 띄어쓰기 까지 검사해서 키워드가 있는데 아니라고 판단해서 크롤링 안될 수 있음
      if (!trimmedValue) return alert("키워드를 입력해주세요!");
      if (notices.includes(trimmedValue)){
        setNotice('');
        return alert("이미 등록된 키워드입니다.");
      } 
      setNotices([...notices, trimmedValue]);
      setNotice('');
      setUpdate(true);
    }
    else if(category==='lost'){
      const trimmedValue = lost.trim();

      if (!trimmedValue) return alert("키워드를 입력해주세요!");
      if (losts.includes(trimmedValue)){
        setLost('');
        return alert("이미 등록된 키워드입니다.");
      } 

      setLosts([...losts, trimmedValue]);
      setLost('');
      setUpdate(true);
    }
  } 

  async function handleSaveAllKeywords() {
    // 현재 화면에 있는 모든 키워드로 배열을 만든다.
    // ...스프레드 연산자를 이용해 1차원 배열로 저장
    const dataToSubmit = [
    ...notices.map((kw) => ({ user_id: sessionId, category: '학교 공지사항', keyword: kw })),
    ...losts.map((kw) => ({ user_id: sessionId, category: '분실물', keyword: kw }))
  ];

    // 기존 키워드 모두 지우기
    const { error: deleteError } = await supabase
      .from('keywords')
      .delete()
      .eq('user_id', sessionId);

    if (deleteError) return alert("기존 데이터 청소 실패");

    // 만약 유저가 모든 키워드를 다 지워버려서 배열이 텅 비었다면?
    // 수파베이스는 빈 배열([])을 insert 하려고 하면 에러를 뱉습니다. 
    // 따라서 넣을 데이터가 있을 때만 insert를 실행하게 안전장치를 걸어준다.
    if (dataToSubmit.length > 0) {
      const { error: insertError } = await supabase
        .from('keywords')
        .insert(dataToSubmit);
        
      if (insertError) {
        alert("키워드 저장 실패: " + insertError.message);
      } else {
        alert("키워드 저장 완료!");
        navigate(-1);
      }
    } else {// 모든키워드 다 지우고 저장 눌렀을 때
      alert("모든 키워드가 삭제되었습니다. 저장 완료!");
      navigate(-1);
    }
  }

  function deleteKeyword(category, targetKeyword) {
    setUpdate(true);
    if (category === 'notice') {
      setNotices(notices.filter((kw) => kw !== targetKeyword));
    } else if (category === 'lost') {
      setLosts(losts.filter((kw) => kw !== targetKeyword));
    }
  }

  function handleKeyDown(category,e){
    if(e.key=='Enter'){
      addKeyword(category);
    }
  }

  function handlekeywordBack(){
    if(update){
      if (window.confirm("저장하지 않고 돌아가시겠습니까?")) {
        navigate(-1); 
      }
    }
    else navigate(-1);
  }

  return(
    <div>
      <div className="keyword-manage-top">
        <BackButton page='keywordManage' handlekeywordBack={handlekeywordBack}/>
        <button className="keyWord-save-btn" onClick={handleSaveAllKeywords}>저장하기</button>
      </div>
      <div>
        <h1>키워드 관리</h1>
        <KeywordSection 
          title="학교 공지사항" 
          category="notice" 
          inputValue={notice} 
          keywordList={notices}
          onChange={handleKeywordChange}
          onAdd={addKeyword}
          onKeyDown={handleKeyDown}
          onDelete={deleteKeyword}
        />
        <KeywordSection 
          title="분실물" 
          category="lost" 
          inputValue={lost} 
          keywordList={losts}
          onChange={handleKeywordChange}
          onAdd={addKeyword}
          onKeyDown={handleKeyDown}
          onDelete={deleteKeyword}
        />
      </div>
    </div>
  );
}
